import styled, { css } from 'styled-components'

const headerPadding = 20

export const Header = styled.div`
    background-color: ${_ => _.theme.header_background};
    padding: ${headerPadding}px;
    position: relative;
    margin-bottom: ${props => (props.mode === 'week' ? '0' : '20px')};

    ${props =>
        props.theme.header_border_color &&
        props.mode !== 'week' &&
        css`
            border-bottom: 16px solid ${props.theme.header_border_color};
        `}

    ${props =>
        props.mode === 'kiosk' &&
        css`
            @media screen and (max-width: 1024px) {
                margin-bottom: 0px;

                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: none;
                padding: 1em 4em;
            }
        `}

    ${props =>
        props.mode === 'kiosk' &&
        css`
            @media screen and (max-width: 1024px) {
                margin-bottom: 0px;

                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: none;
                padding: 1em 4em;
            }
        `}

    ${props =>
        props.mode === 'day' &&
        css`
            @media screen and (max-width: 1024px) {
                h2 {
                    text-align: right;
                }
            }
        `}



    font-family: ${_ => _.theme.header_font_family};
    font-size: ${_ => _.theme.header_font_size || 'initial'};
`

export const Logo = styled.img`
    position: absolute;
    top: 0px;
    left: ${props => (props.mode === 'week' ? '5%' : '15%')};
    height: ${props => (props.mode === 'week' ? '98px' : '112px')};

    ${props =>
        props.mode === 'kiosk' &&
        css`
            @media screen and (max-width: 1300px) {
                position: relative;
                left: 0px;
            }

            @media screen and (min-width: 1600px) {
                position: relative;
                left: 0px;
            }
        `}

    @media screen and (max-width: 768px) {
        position: absolute;
        left: 26px;
        height: 60px;
        margin-bottom: 1em;
    }
`

export const Title = styled.h1`
    font-size: ${_ => (_.titleFontSize ? _.titleFontSize : '1.5em')};
    font-weight: 400;
    color: ${_ => _.theme.header_font_color};
    margin: 0;
    line-height: ${_ =>
        _.lineHeight ? _.lineHeight - headerPadding + 'px' : 'auto'};

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const SubTitle = styled.h2`
    font-size: 1em;
    font-weight: 400;
    color: ${_ => _.theme.header_font_color};
    margin: 0;
    margin-top: 0.25em;
    line-height: ${_ =>
        _.lineHeight ? _.lineHeight - headerPadding + 'px' : 'auto'};

    @media screen and (max-width: 768px) {
        position: absolute;
        right: 20px;
        bottom: 1px;
    }
`

export const Week = styled.h2`
    font-size: 1em;
    font-weight: 200;
    color: ${_ => _.theme.header_font_color};
    text-transform: uppercase;
    margin: 0;
    letter-spacing: 2px;
`
